module.exports = __webpack_public_path__ + "img/unload-3-2.d9727a82.png";